// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"loading_loading-wrapper__37Olw","loading-content":"loading_loading-content__b3Cf7"};